import cn from "classnames"

import { Flex } from "@/atoms"
import { LinkOutlined } from "@/icons"

import styles from "./CorrelationFieldsTemplate.module.scss"

import type { CorrelationFieldsTemplateProps } from "."

export const CorrelationFieldsTemplate = (
  props: CorrelationFieldsTemplateProps
) => {
  const { children, hide, isSelected } = props

  return (
    <Flex className={cn(styles.container, { [styles.hide]: hide })}>
      <div className={styles.connector}>
        <span className={cn(styles.connectorLine, styles.connectorLineTop)} />
        <span
          className={cn(
            styles.connectorIcon,
            isSelected && styles.connectorIconSelected
          )}
        >
          <LinkOutlined />
        </span>
        <span
          className={cn(styles.connectorLine, styles.connectorLineBottom)}
        />
      </div>
      <Flex vertical flex={1} className={styles.formWrapper}>
        {children}
      </Flex>
    </Flex>
  )
}
